<template>
    <!-- 食品留样记录表 -->
    <div>
      <el-row>
        <!-- 工具条 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
          @submit.native.prevent>
          <el-form-item label="留样日期">
            <el-date-picker
              v-model="formInline.dayStr"
              type="date"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search" plain>查询</el-button>
            <el-button type="warning" icon="el-icon-plus" @click="addContract" plain>添加</el-button>
            <el-button
                type="info"
                @click="exportExcel"
                icon="el-icon-download"
                plain>记录导出</el-button>
          </el-form-item>
        </el-form>
        <el-table style="width: 100%" :data="tableData" v-loading="tableLoading" :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
          <el-table-column prop="dayStr" label="留样日期" min-width="80"></el-table-column>
          <el-table-column prop="time" label="时间" min-width="70"></el-table-column>
          <el-table-column prop="can" label="三餐" min-width="60"></el-table-column>
          <el-table-column prop="foodName" label="食品名称" min-width="120"></el-table-column>
          <el-table-column prop="foodWeight" label="留样重量(g)" min-width="120"></el-table-column>
          <el-table-column prop="producer" label="食物制作人" min-width="100"></el-table-column>
          <el-table-column prop="holder" label="留样人" min-width="100"></el-table-column>
          <el-table-column prop="destroyTime" label="留样销毁日期" min-width="180"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
          <el-table-column label="操作" min-width="80">
            <template slot-scope="scope">
              <a @click="handleEdit(scope.$index, scope.row)" class="curcor">
                <img class="handedness" src="@/assets/beadhouse/xiugai_icon_1.png" />
              </a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize" align="center" class="fenye">
        </el-pagination>

      <el-dialog title="新增留样记录表" :visible.sync="dialogVisible" width="450px" :close-on-click-modal="false"
      :close-on-press-escape="false" class="bangdilocation">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="留样日期:" prop="dayStr">
            <el-date-picker
            v-model.trim="addForm.dayStr"
            type="date"
            style="width: 90%"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="留样时间:" prop="time">
          <el-time-select
          v-model="addForm.time"
          placeholder="选择时间">
        </el-time-select>
        </el-form-item>
        <el-form-item label="三餐:" prop="can">
            <el-input v-model.trim="addForm.can" auto-complete="off" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="食品名称:" prop="foodName">
          <el-input v-model.trim="addForm.foodName" auto-complete="off" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="留样重量:" prop="foodWeight">
          <el-input v-model.trim="addForm.foodWeight" auto-complete="off" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="食物制作人:" prop="producer">
          <el-input v-model.trim="addForm.producer" auto-complete="off" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="留样人:" prop="holder">
          <el-input v-model.trim="addForm.holder" auto-complete="off" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="留样销毁日期:" prop="destroyTime">
          <el-date-picker
            v-model.trim="addForm.destroyTime"
            type="date"
            style="width: 90%"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model.trim="addForm.remark" auto-complete="off" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitaddForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
      </el-row>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  import { baseURL } from "@/utils/request.js";
  export default {
    name: "FoodRetention",
    data() {
      return {
        formInline: {
          dayStr: "",
        },
        tableData: [], //表格数据
        tableLoading: false, //表格加载的loading
        /* 分页的 */
        currentPage: 1, //初始页
        pageNo: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber: 0, //数据的总数,
        fieldsVisisble: false,
        oldNameOptions: [], // 老人姓名集合
        dialogVisible:false,
        addForm:{
          day:"",
          food:"",
          man:""
        },
      };
    },
    methods: {
      //修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      /*
        添加
      */
      addContract() {
        this.dialogVisible = true;
        this.addForm = {};

      },
      handleEdit(index, row) {
        this.addForm = Object.assign({},row);
        this.dialogVisible = true;
      },
      submitaddForm(){
        let param = this.addForm;
        this.$postJson(
          this.addForm.id
            ? "omc/foodRetention/update"
            : "omc/foodRetention/add",
          param
        ).then(res=>{
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.queryContract(); //重新渲染页面
            this.$nextTick(() => {
              this.dialogVisible = false; //关闭弹框
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
      },
      //导出
      exportExcel() {
        window.location.href =
        baseURL +
        `omc/api/downFoodRetentionRecordExcel?groupId=${window.sessionStorage.getItem("groupId")}`;
      },
      /*
        点击查询
      */
      search() {
        this.queryContract(
          (this.pageNo = 1),
          (this.pageSize = 10)
        );
      },
      /*
        键盘事件 按下键盘回车 查询
      */
      enterSearchMember(e) {
        // console.log("回车搜索", keyCode, e);
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13 && this.formInline.oldName != null) {
          this.search();
        }
      },
      /*
        查询老人分页列表
      */
      queryContract() {
        let params = {};
        params.pageNo = String(this.pageNo);
        params.pageSize = String(this.pageSize);
        params.dayStr = String(this.formInline.dayStr);
        this.tableData = [];
        this.tableLoading = true;
        this.$postJson("omc/foodRetention/selectShowAll", params).then((res) => {
          if (res.code == 200) {
            if (res.result.list != null) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.tableData = res.result.list;
            } else {
              this.tableData = [];
              this.pageSize = 10;
              this.currentPage = 1;
              this.totalDataNumber = 0;
            }
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
          setTimeout(() => {
            this.tableLoading = false;
          }, 500);
        });
      },
      /*
        当前页变化
      */
      handleCurrentChange(val) {
        this.pageNo = val;
        this.queryContract(); //刷新套餐列表的数据
      },
    },
    mounted() {
      this.queryContract();
    },
    computed: {},
  };
  </script>
  <style lang="scss" scoped>
  .fenye {
    padding: 30px 0;
    background: #fff;
  }
  </style>
    